import { render, staticRenderFns } from "./SetList.vue?vue&type=template&id=71830e10&scoped=true&"
import script from "./SetList.vue?vue&type=script&lang=js&"
export * from "./SetList.vue?vue&type=script&lang=js&"
import style0 from "./SetList.vue?vue&type=style&index=0&id=71830e10&scoped=true&lang=css&"
import style1 from "./SetList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71830e10",
  null
  
)

export default component.exports